import EventExplorationFilter from "@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter";
import EventFilterRequiredWrap from "@/pages/dashboard/pages/eventAnalysis/EventExploration/components/EventFilterRequiredWrap";

export default {
  EventExplorationFilter,
  EventFilterRequiredWrap,
};
